import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface BillingInformationTabProps {
  billingContactName: string;
  setBillingContactName: (value: string) => void;
  billingContactEmail: string;
  setBillingContactEmail: (value: string) => void;
  updatingBillingContact: boolean;
  hasBillingContactChanges: boolean;
  handleSaveBillingContact: () => Promise<void>;
}

export function BillingInformationTab({
  billingContactName,
  setBillingContactName,
  billingContactEmail,
  setBillingContactEmail,
  updatingBillingContact,
  hasBillingContactChanges,
  handleSaveBillingContact,
}: BillingInformationTabProps) {
  return (
    <div className="space-y-6">
      <Card className="p-6 border-border">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="space-y-2 lg:max-w-xl">
            <h3 className="text-lg font-semibold">Accounting Team</h3>
            <p className="text-sm text-muted-foreground">
              Send billing receipts, invoices, and overage confirmations to your finance team instead of the default workspace admin contact.
            </p>
          </div>
          <Button
            onClick={() => void handleSaveBillingContact()}
            disabled={updatingBillingContact || !hasBillingContactChanges}
          >
            {updatingBillingContact ? "Saving..." : "Save billing contact"}
          </Button>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="billing-contact-name">Team name</Label>
            <Input
              id="billing-contact-name"
              placeholder="Accounts Payable"
              maxLength={80}
              value={billingContactName}
              onChange={(event) => setBillingContactName(event.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="billing-contact-email">Billing email</Label>
            <Input
              id="billing-contact-email"
              type="email"
              placeholder="finance@yourcompany.com"
              value={billingContactEmail}
              onChange={(event) => setBillingContactEmail(event.target.value)}
            />
          </div>
        </div>

        <p className="mt-3 text-xs text-muted-foreground">
          Leave this blank to keep billing emails routed to the workspace admin handling billing.
        </p>
      </Card>
    </div>
  );
}
